import React, { useEffect, useRef } from 'react';
import {
  getMemberCardEffectCss,
  injectMemberCardEffectStyles,
  attachMemberCardTiltHandlers,
} from './memberCardEffectStyles';

/** Read-only HTML preview for calendar writer / rider content (web). */
export function WriterHtmlView({ html, theme }) {
  const wrapRef = useRef(null);
  const safeHtml = String(html || '');

  useEffect(() => {
    injectMemberCardEffectStyles(true);
  }, []);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return undefined;
    return attachMemberCardTiltHandlers(el);
  }, [safeHtml]);

  if (!safeHtml.trim()) return null;

  return (
    <div ref={wrapRef} style={{ width: '100%' }}>
      <div className="vrc-writer-html-view" dangerouslySetInnerHTML={{ __html: safeHtml }} />
      <style>{`
        .vrc-writer-html-view {
          color: ${theme.text.primary};
          font-size: 14px;
          line-height: 1.55;
        }
        .vrc-writer-html-view h1 {
          font-size: 22px;
          font-weight: 800;
          margin: 12px 0 8px;
        }
        .vrc-writer-html-view h2 {
          font-size: 17px;
          font-weight: 800;
          margin: 10px 0 6px;
        }
        .vrc-writer-html-view p {
          margin: 0 0 8px;
        }
        .vrc-writer-html-view ul {
          margin: 0 0 10px 18px;
          padding: 0;
        }
        .vrc-writer-html-view .vrc-writer-member-notes p {
          margin: 0;
          color: ${theme.text.secondary};
        }
        ${getMemberCardEffectCss(true)}
      `}</style>
    </div>
  );
}

export default WriterHtmlView;
